import Vue from 'vue'
import App from './App.vue'
import {initRouter} from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import './theme/index.less'
import Antd from 'ant-design-vue'
import Viser from 'viser-vue'
// import '@/mock'
import store from './store'
import 'animate.css/source/animate.css'
import Plugins from '@/plugins'
import {initI18n} from '@/utils/i18n'
import bootstrap from '@/bootstrap'
import 'xe-utils'  // https://blog.csdn.net/weixin_43801653/article/details/107907562
// import BaiduMap from 'vue-baidu-map'
import $ from 'jquery'
// Vue.use(BaiduMap, {
// 	// ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
// 	ak: process.env.VUE_APP_BAIDUMAP_AK
// })

import "@/utils/tool/index"
import "@/utils/tool/directive"
import moment from 'moment';
import 'moment/locale/zh-cn'
moment.locale('zh-cn');

Vue.prototype.bus = new Vue;

// Base64加密
// import Base64 from 'js-base64'
// Vue.use(Base64)


// 引入echarts
import * as $echarts from 'echarts';

Vue.prototype.$echarts = $echarts



// import ECharts from 'vue-echarts'
// Vue.component('v-chart', ECharts) 
// qf41

import Print from './utils/print'
Vue.use(Print)

import commComponents from '@/utils/components';



import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

Vue.use(VXETable);

Vue.use(commComponents)

// 从Vuex store的setting模块获取asyncRoutes状态
// 表示是否启用异步路由功能
// 通常是一个布尔值(true/false)
// 根据asyncRoutes的值决定路由初始化模式
// true: 使用异步路由配置(从src/router/async/config.async.js加载)
// false: 使用基本路由配置(从src/router/config.js加载)
const router = initRouter(store.state.setting.asyncRoutes)
const i18n = initI18n('CN', 'US')

Vue.prototype.$ = $
Vue.use(Antd)
Vue.config.productionTip = false
Vue.use(Viser)
Vue.use(Plugins)

Vue.prototype.console = console;

//引入通用样式表和项目样式表
import '@/assets/css/common.css'
import '@/assets/css/base.less'
import '@/assets/css/smallSize.less'



Vue.prototype.$message.config({
  maxCount: 4,
})
// qf42
bootstrap({router, store, i18n, message: Vue.prototype.$message})
import * as filters from './filters' // global filters
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
